/**
 * Adapptio Integration extensions base library.
 *
 * @package ext-integrations-base
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { SYSTEM_ERRORS } from "./errorCodes/system";
import { ERROR_NAMES } from "./ErrorNames";
import { TErrors } from "./IError";

/**
 * Returns error name
 *
 * @param error Error
 * @param defaultName Default error name
 * @param errorsList Error list
 * @param nameList
 * @returns
 */
export function getErrorName(error: any, defaultName: string): string {
	// Network Error
	if ([ "connect", "getaddrinfo" ].includes(error?.syscall) && SYSTEM_ERRORS[error?.code]) {
		return ERROR_NAMES.NETWORK;
	}

	return defaultName;
}

export function getErrorMessage(error: any, defaultMessage: string, errorsList: TErrors[] = []): string {
	if (error instanceof Object && 'message' in error && typeof error.message === 'string') {
		return error.message;
	}

	// Network Error Message
	if (SYSTEM_ERRORS[error?.code]) {
		return SYSTEM_ERRORS[error.code];
	}

	if (!errorsList) {
		return defaultMessage;
	}

	for (const errors of Object.values(errorsList)) {
		if (errors[error?.code]) {
			return errors[error?.code];
		}
	}

	return defaultMessage;
}
